// extracted by mini-css-extract-plugin
export var originalPrice = "_vj-0";